module.exports = __webpack_public_path__ + "static/media/sebastien-gabrieles.3c62f394.jpg";